import React from 'react';
import { ArrowDown, Calendar, ChevronDown, ChevronLeft, ChevronRight, CircleAlert, CircleCheck, Info, TriangleAlert, X } from 'lucide-react';

/*
 * Brand glyphs for MUI's built-in controls (book §11.5): a 16px square
 * checkbox (radius 4) and a 16px radio, Blue 500 when on. Their look lives
 * in the `.sbg-check` rules of the theme's CssBaseline so the checked,
 * disabled and focus states can follow the MUI state classes.
 */

export const CheckboxIcon: React.FC = () => <span className="sbg-check" aria-hidden="true" />;

export const CheckboxCheckedIcon: React.FC = () => (
  <span className="sbg-check sbg-check--on" aria-hidden="true">
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
      <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

export const CheckboxIndeterminateIcon: React.FC = () => (
  <span className="sbg-check sbg-check--on" aria-hidden="true">
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M2 5h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  </span>
);

export const RadioIcon: React.FC = () => <span className="sbg-check sbg-check--radio" aria-hidden="true" />;

export const RadioCheckedIcon: React.FC = () => (
  <span className="sbg-check sbg-check--radio sbg-check--radio-on" aria-hidden="true">
    <span className="sbg-check__dot" />
  </span>
);

type GlyphProps = { className?: string; onClick?: React.MouseEventHandler<SVGSVGElement> };

/** Select and Autocomplete chevron (16px). */
export const SelectChevron: React.FC<GlyphProps> = ({ className }) => (
  <ChevronDown size={16} className={className} aria-hidden="true" />
);

/** Sort arrow for TableSortLabel (MUI rotates it for ascending). */
export const SortArrow: React.FC<GlyphProps> = ({ className }) => (
  <ArrowDown size={14} className={className} aria-hidden="true" />
);

export const ChipDeleteIcon: React.FC<GlyphProps> = ({ className, onClick }) => (
  <X size={14} className={className} onClick={onClick} aria-hidden="true" />
);

export const ClearGlyph: React.FC<GlyphProps> = ({ className }) => <X size={14} className={className} aria-hidden="true" />;
export const CalendarGlyph: React.FC<GlyphProps> = ({ className }) => <Calendar size={16} className={className} aria-hidden="true" />;
export const PrevGlyph: React.FC<GlyphProps> = ({ className }) => <ChevronLeft size={18} className={className} aria-hidden="true" />;
export const NextGlyph: React.FC<GlyphProps> = ({ className }) => <ChevronRight size={18} className={className} aria-hidden="true" />;

export const alertIcons = {
  info: <Info size={20} />,
  success: <CircleCheck size={20} />,
  warning: <TriangleAlert size={20} />,
  error: <CircleAlert size={20} />,
};
